import { gelatoItems, pastryItems, beverageItems } from '@/mocks/menuData';
import MenuCarousel from './MenuCarousel';

const featureImages = {
  gelato: 'https://storage.helloreaddy.io/project_files/67b99c16-3b28-4507-9f93-7295101e045c/9f008189-1be3-4424-945f-c50126e91070_compressed_Screenshot-2026-07-30-215819.webp',
  pastry: 'https://storage.readdy-site.link/project_files/67b99c16-3b28-4507-9f93-7295101e045c/8d144f97-871d-4ffa-9652-30a6387a5942_compressed_Screenshot-2026-07-22-014240.webp',
  beverage: 'https://storage.readdy-site.link/project_files/67b99c16-3b28-4507-9f93-7295101e045c/30666bf0-685d-4983-9ce7-b6681311931d_compressed_Screenshot-2026-07-22-014430.webp',
};

export default function MenuSection() {
  return (
    <section id="menu" className="w-full bg-background-900 py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="text-center mb-16">
          <h2 className="font-heading text-4xl md:text-5xl text-primary-400 glow-text">
            Detailed Menu
          </h2>
          <div className="w-12 h-[2px] bg-primary-500/50 mx-auto mt-4"></div>
        </div>

        <MenuCarousel
          title="Gelato"
          items={gelatoItems}
          featureImage={featureImages.gelato}
        />

        <MenuCarousel
          title="Pastries"
          items={pastryItems}
          featureImage={featureImages.pastry}
          imageOnLeft
        />

        <MenuCarousel
          title="Beverages"
          items={beverageItems}
          featureImage={featureImages.beverage}
        />
      </div>
    </section>
  );
}